import * as React from "react";
import * as Survey from "survey-react";

import {
  CustomerFormTypeData,
  PersonRequest,
} from "@plinknz/tah-website-elements";

import { createSurveyConfig as kirihimeteSurveyConfig } from "../../../service/forms/kirihimete-whanau-survey-config";
import { createSurveyConfig as manawaSurveyConfig } from "../../../service/forms/manawa-energy-survey-config";
import { createSurveyConfig as puteaTautokoSurveyConfig } from "../../../service/forms/putea-tautoko-survey-config";
import { createSurveyConfig as rangatahiWanangaSurveyConfig } from "../../../service/forms/rangatahi-wananga/config";
import { createSurveyConfig as tunaSurveyConfig } from "../../../service/forms/tuna-wananga-survey-config";
import { createSurveyConfig as whanauInitiativesReportSurveyConfig } from "../../../service/forms/whanau-initiatives-report-survey/config";
import { createSurveyConfig as whanauInitiativesSurveyConfig } from "../../../service/forms/whanau-initiatives-survey/config";
import { createSurveyConfig as whanauReoSurveyConfig } from "../../../service/forms/whanau-reo/config";
import { transformBenefitFormData } from "../../../utility/form-transforms/transform-benefit-form-data";

import { BenefitForm } from "./benefit-form";
import { ContactForm } from "./contact-form";
import { RegistrationForm } from "./registration-form";
import { questionTypes } from "../../../utility/form-transforms/question-types";
import { PageConfig } from "./customer-form-types";

interface CustomerFormBlockProps {
  data: CustomerFormTypeData;
}

export const CustomerFormBlock = ({
  data: { active, type, email, emailSubject, targetType },
}: CustomerFormBlockProps) => {
  if (!active) {
    return <div data-testid="inactive-form" />;
  }
  const transformData = (
    survey: Survey.ReactSurveyModel,
    member: PersonRequest,
    config: { pages: PageConfig[] }
  ) =>
    transformBenefitFormData(
      survey,
      member,
      config,
      type,
      email,
      emailSubject,
      targetType
    );

  switch (type) {
    case "contact":
      return <ContactForm />;
    case "Tautoko Putea Grant":
      return (
        <BenefitForm
          createSurveyConfig={puteaTautokoSurveyConfig}
          transformData={transformData}
          questionTypes={questionTypes(puteaTautokoSurveyConfig)}
        />
      );
    case "registration":
      return <RegistrationForm />;
    case "Tuna Wānanga":
      return (
        <BenefitForm
          createSurveyConfig={tunaSurveyConfig}
          transformData={transformData}
          questionTypes={questionTypes(tunaSurveyConfig)}
        />
      );
    case "Kirihimete Whānau":
      return (
        <BenefitForm
          createSurveyConfig={kirihimeteSurveyConfig}
          transformData={transformData}
          questionTypes={questionTypes(kirihimeteSurveyConfig)}
        />
      );
    case "Manawa Energy Taiao Scholarship":
      return (
        <BenefitForm
          createSurveyConfig={manawaSurveyConfig}
          transformData={transformData}
          questionTypes={questionTypes(manawaSurveyConfig)}
        />
      );
    case "Whānau Initiatives Fund":
      return (
        <BenefitForm
          createSurveyConfig={whanauInitiativesSurveyConfig}
          transformData={transformData}
          questionTypes={questionTypes(whanauInitiativesSurveyConfig)}
        />
      );
    case "Whānau Initiatives Fund Report":
      return (
        <BenefitForm
          createSurveyConfig={whanauInitiativesReportSurveyConfig}
          transformData={transformData}
          questionTypes={questionTypes(whanauInitiativesReportSurveyConfig)}
        />
      );
    case "Rangatahi Wānanga":
      return (
        <BenefitForm
          createSurveyConfig={rangatahiWanangaSurveyConfig}
          transformData={transformData}
          questionTypes={questionTypes(rangatahiWanangaSurveyConfig)}
        />
      );
    case "Whānau Reo":
      return (
        <BenefitForm
          createSurveyConfig={whanauReoSurveyConfig}
          transformData={transformData}
          questionTypes={questionTypes(whanauReoSurveyConfig)}
        />
      );
    default:
      return <div data-testid="unknown-form" />;
  }
};
